function ServiceDateTemplate(service) {
    return new Date(service.dateService).toLocaleDateString();
}

export default ServiceDateTemplate;
